import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAgGridExportService } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import { IrbModelsEvents } from '../irb-models.events';
import { ISecurityHardDataInfo, SecurityMasterService } from '../security-master/security-master.service';
import { DeleteSecurityErrorModelContainsGridLayoutService } from './delete-security-error-model-contains.grid-layout.service';

@Component({ standalone: false,
  selector: 'irb-delete-securities-error-dialog',
  templateUrl: './delete-securities-error-dialog.component.html',
  styleUrls: ['./delete-securities-error-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DeleteSecuritiesErrorDialogComponent implements OnInit {

  deleteSecurities: Array<any>;
  deletedSelectedIds: Array<any>;
  nonDeletedSecurity: Array<any>;
  deleteContinueFunction: Function;
  grid: any;
  gridOptions: any;
  checkdeleteModels:any=[];
  modelArray:any=[];
  cashFlag:boolean;
  totalCount:number;
  gridCount:number;
  private exportPayload: string = '';
  strGridData: string = '';
  private exportFileName = 'DeleteSecurity';
  columnHeaders = ['Symbol', 'Reason', 'Location'];
  isUiTest = false;
  frameworkComponents: any;

  constructor(public dialogRef: MatDialogRef<DeleteSecuritiesErrorDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private as: AppService,
   private readonly securitiesService: SecurityMasterService,private gls: DeleteSecurityErrorModelContainsGridLayoutService,public ges: IrbAgGridExportService,
   ) { 

    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this },
      suppressHorizontalScroll: true
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
   }

  ngOnInit(): void {
    this.deleteSecurities = this.data.deleteSecurities;
    this.totalCount=this.data.gridCount;
    this.getGridData();
  }

  getGridData() {
    this.deleteSecurities.forEach((item: ISecurityHardDataInfo) => {
      this.strGridData += item.symbol + ',' + item.reason + ',' + item.location + '\n';
    });
  }

  close() {
    if(this.dialogRef.close !== undefined)
     this.dialogRef.close();
  }

  completeContains() {   
    this.as.fireEvent(IrbModelsEvents.SHOW_DELETE_SECURITIES_DIALOG,this.data);

    this.close();

  }

  onGridReady(params: any) {
    this.grid = params;
    //this.grid.api.sizeColumnsToFit();
  }

  export() {
    this.exportPayload += this.columnHeaders[0] + ',' + this.columnHeaders[1] + ',' + this.columnHeaders[2] + '\n';
    this.exportPayload += this.strGridData;
    this.ges.setPrefix(this.exportFileName, "csv");
    const blob = new Blob([this.exportPayload]);
    this.ges.download(blob);
  }

}
